import _ from 'underscore';

export const getVerifiedTrackingSettingWrite = (verifiedTrackingSettings = null) => {
  if (_.isNull(verifiedTrackingSettings)) {
    return {};
  }

  if (_.isEmpty(verifiedTrackingSettings)) {
    return { VerifiedTrackingData: '' };
  }

  const results = [];
  _.each(verifiedTrackingSettings, (setting) => {
    const result = [];
    if (setting.vendorName === 'DV') {
      result.push({ Key: 'vendorName', Value: 'DV' });
      if (setting.enabled === true) {
        result.push({ Key: 'settings', Value: '' });
      } else {
        result.push({ Key: 'enabled', Value: 'false' });
      }
    } else {
      _.mapObject(setting, (value, key) => {
        result.push({ Key: key, Value: value });
      });
    }

    results.push(result);
  });

  return { VerifiedTrackingData: JSON.stringify(results) };
};

export const getVerifiedTrackingSettingsRead = (model, customKey = null) => {
  const verifiedTrackingSettings = _.get(model, 'VerifiedTrackingSettings');

  if (!verifiedTrackingSettings || verifiedTrackingSettings.length === 0) {
    return {};
  }
  const results = [];

  verifiedTrackingSettings.forEach((setting) => {
    const vendor = _.get(setting, 'VerifiedTrackingVendor');

    if (!_.isString(vendor)) {
      return;
    }

    if (!_.isEqual(vendor, 'IAS') && !_.isEqual(vendor, 'DV') && !_.isEqual(vendor, 'ISPOT')) {
      return;
    }

    const result = {};

    result.vendorName = vendor;
    if (_.isEqual(vendor, 'MOAT')) {
      results.push(result);
      return;
    }

    const data = _.get(setting, ['VerifiedTrackingData', 0, 'Data']);

    if (!_.isObject(data) || _.isEmpty(data)) {
      return;
    }

    const keys = _.get(data, 'Keys');

    if (!_.isArray(keys) || _.isEmpty(keys)) {
      return;
    }

    const values = _.get(data, 'Values');

    if (!_.isArray(values) || _.isEmpty(values)) {
      return;
    }

    const keyMap = {
      IAS_advertiserEntityId: 'advertiserEntityId',
      IAS_publisherEntityId: 'publisherEntityId',
      ISPOT_brandId: 'brandId',
    };

    _.each(keys, (key, index) => {
      if (keyMap[key]) {
        result[keyMap[key]] = values[index];
      }
    });
    results.push(result);
  });

  if (!_.isEmpty(customKey)) {
    return { [customKey]: results };
  }

  return { VerifiedTrackingSettings: results };
};

export const thirdPartyMeasurementStringToViewModel = (verifiedTrackingDataString = '') => {
  if (_.isEmpty(verifiedTrackingDataString)) {
    return [];
  }

  let thirdPartyMeasurementFromBulkModel = {};
  try {
    thirdPartyMeasurementFromBulkModel = JSON.parse(verifiedTrackingDataString);
  } catch (e) {
    console.log(e);
    return [];
  }

  if (!_.isArray(thirdPartyMeasurementFromBulkModel) || thirdPartyMeasurementFromBulkModel.length === 0) {
    return [];
  }

  const results = [];
  thirdPartyMeasurementFromBulkModel.forEach((thirdPartyMeasurementSetting) => {
    if (!_.isArray(thirdPartyMeasurementSetting)) {
      return;
    }
    const result = {};
    _.each(thirdPartyMeasurementSetting, (setting) => {
      result[setting.Key] = setting.Value;
    });

    results.push(result);
  });

  return results;
};
